import type { Block, TextBlockContent } from '@/types';
import RichTextEditor from './RichTextEditor';

interface TextBlockProps {
  block: Block;
  isEditable?: boolean;
  onUpdate?: (patch: Partial<Block>) => void;
}

function TextBlock({ block, isEditable = false, onUpdate }: TextBlockProps) {
  const content = block.content as TextBlockContent;

  if (isEditable) {
    return (
      <RichTextEditor
        content={content.html || ''}
        onChange={(html) => {
          onUpdate?.({
            content: {
              ...content,
              html,
            },
          });
        }}
        minHeight={100}
      />
    );
  }

  return (
    <div
      style={{ textAlign: content.alignment || 'left' }}
      className="[&_h1]:text-[1.75em] [&_h1]:font-bold [&_h1]:my-0 [&_h1]:mb-[0.5em] [&_h2]:text-[1.5em] [&_h2]:font-semibold [&_h2]:my-0 [&_h2]:mb-[0.5em] [&_h3]:text-[1.25em] [&_h3]:font-semibold [&_h3]:my-0 [&_h3]:mb-[0.5em] [&_p]:my-0 [&_p]:mb-[0.5em] [&_ul]:pl-6 [&_ul]:my-0 [&_ul]:mb-[0.5em] [&_ol]:pl-6 [&_ol]:my-0 [&_ol]:mb-[0.5em] [&_blockquote]:border-l-[3px] [&_blockquote]:border-gray-300 [&_blockquote]:pl-4 [&_blockquote]:ml-0 [&_blockquote]:italic [&_a]:text-primary [&_a]:underline"
    >
      <div dangerouslySetInnerHTML={{ __html: content.html || '' }} />
    </div>
  );
}

export default TextBlock;
